<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/l-audio/l-audio.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">Luxury Audio System Showcase</div>
                <div class="detail-banner-desc">文案待提供</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>

                    <div class="detail-desc">
                        <div>
                            7.3.6 luxury audio system solution visualization showcase, with premium amplifiers and featured speakers.<br />
                        </div>
                        <div>
                            Self-developed products with platform-based design, offering mature and reliable mass-production solutions.<br />
                        </div>
                        <div>
                            Deliver luxury audio experience.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/l-audio/l-audio-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">AD20 20CH DSP Amplifier</div>
                                    <div class="k">Amplifier</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">AD12 12CH DSP Amplifier</div>
                                    <div class="k">Amplifier</div>
                                </div>
                                <div class="spec-item spec-item-full">
                                    <div class="v">2CH Discrete Booster</div>
                                    <div class="k">Amplifier</div>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">25mm Professional Series Tweeter</div>
                                    <div class="k">Speaker</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">30mm Ultra-Thin Ceiling Mid-High</div>
                                    <div class="k">Speaker</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">65mm Professional Series Surround Speaker</div>
                                    <div class="k">Speaker</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/l-audio/l-audio-1.jpg" alt="200-1-02">
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/l-audio/l-audio-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">100mm Professional Series Midrange (Center)</div>
                                    <div class="k">Speaker</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">100mm Professional Series Midrange (Door)</div>
                                    <div class="k">Speaker</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">130mm Dual Core Subwoofer</div>
                                    <div class="k">Speaker</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">224mm Professional Series Subwoofer</div>
                                    <div class="k">Speaker</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">165mm Professional Series 3-Way Door Woofer</div>
                                    <div class="k">Speaker</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/l-audio/l-audio-1.jpg" alt="200-1-02">
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: 'Luxury Audio System Showcase - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/l-audio.html'

};

import { createApp } from 'vue';
import App from './l-audio.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./l-audio.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
